import React, { forwardRef, useImperativeHandle, useState, useRef, CSSProperties } from 'react';

interface TextAreaProps {
    label: string;
    inputId: string;
    required?: boolean;
    errorMessage?: string;
    placeholder?: string;
    rows?: number;
    value: string; // value prop'u tanımlandı
    onChange: (value: string) => void; // onChange prop'u tanımlandı
    style?: CSSProperties | null; // style prop'u ekleniyor
    onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void | null; // onKeyDown event'i isteğe bağlı
    showHeader?: boolean; // showHeader parametresi eklendi
}

export interface TextAreaHandle {
    validate: () => boolean;
    showError: () => void;
    getValue: () => string;
    setValue: (value: string) => void;
}

const TextArea = forwardRef<TextAreaHandle, TextAreaProps>(({
    label,
    inputId,
    required = false,
    errorMessage,
    placeholder,
    rows = 3,
    value, // value prop'u alınıyor
    onChange, // onChange prop'u alınıyor
    style = null, // style prop'u varsayılan olarak null
    onKeyDown = null, // onKeyDown varsayılan olarak null
    showHeader = true
}, ref) => {
    const [isValid, setIsValid] = useState(true);
    const inputRef = useRef<HTMLTextAreaElement | null>(null);

    useImperativeHandle(ref, () => ({
        validate: () => {
            const currentValue = inputRef.current?.value;
            if (required && !currentValue?.trim()) {
                setIsValid(false);
                return false;
            }
            setIsValid(true);
            return true;
        },
        showError: () => {
            setIsValid(false);
        },
        getValue: () => {
            return inputRef.current?.value || '';
        },
        setValue: (newValue: string) => {
            if (inputRef.current) {
                inputRef.current.value = newValue;
            }
        }
    }));

    return (
        <div className="form-group">
            {/* showHeader true ise label gösterilir */}
            {showHeader && (
                <label className="form-label" htmlFor={inputId}>
                    {label}
                </label>
            )}
            <textarea
                id={inputId}
                className={`form-control mb-0 ${!isValid ? 'is-invalid' : ''}`}
                required={required}
                placeholder={placeholder}
                rows={rows}
                ref={inputRef}
                value={value} // value prop'u bağlanıyor
                onChange={(e) => onChange(e.target.value)} // event.target.value alıyoruz
                style={style ?? {}} // style prop'u null değilse uygulanıyor, yoksa boş stil kullanılıyor
                onKeyDown={onKeyDown ?? undefined} // onKeyDown event'i null değilse atanıyor
            />
            {!isValid && (
                <div className="invalid-feedback">
                    {errorMessage}
                </div>
            )}
        </div>
    );
});

export default TextArea;
